import { render, staticRenderFns } from "./formApplicant.vue?vue&type=template&id=206c6969&scoped=true"
import script from "./formApplicant.vue?vue&type=script&lang=js"
export * from "./formApplicant.vue?vue&type=script&lang=js"
import style0 from "./formApplicant.vue?vue&type=style&index=0&id=206c6969&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206c6969",
  null
  
)

export default component.exports